import React from 'react';
import GreenLeafApi from '../utils/GreenLeafApi';
import * as moment from 'moment';
import NotFoundPage from '../NotFoundPage';
import AssessmentPage from './AssessmentPage';
import ProgressBarItem from './ProgressBar';
import ErrorComponent from '../ErrorComponent';


class CoachReportPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      team: {},
      assessments: {},
      answers: {},
      score: [],
      subScores: [],
      loading: true,
      notAssessed: false,
      notFound: false,
      user: '',
      errors: []
    };
  }

  async componentDidMount() {
    try {
      let team = (await GreenLeafApi.Team.get({teamId: this.props.match.params.teamId})).data[0];
      this.setState({notFound: !team});
      if(team) {
        let score = (await GreenLeafApi.TeamAssessment.getScore({team_assessment_id: this.props.match.params.teamAssessmentId})).data.score;
        score[0].id = this.props.match.params.teamAssessmentId;

        let subsectionScores = (await GreenLeafApi.TeamAssessment.getSubScores({team_assessment_id: this.props.match.params.teamAssessmentId})).data.scores;

        if (score.length === 0 || subsectionScores.length === 0)
          this.setState({notAssessed: true});
        else {
          let assessments = (await GreenLeafApi.TeamAssessment.getAnswers({team_assessment_id: this.props.match.params.teamAssessmentId})).data;

          let answers = assessments.assessment.reduce((res, a) => {
            res[a.question_id] = {answer: a.answer_id, comment: a.question_comment};
            return res;
          }, {});

          this.setState({
            team,
            assessments,
            answers,
            score,
            subScores: subsectionScores,
            user: score[0].user_name || 'N/A'
          });
        }
      }
    } catch (e) {
      this.setState({ errors: e.errors });
    }

    this.setState({loading: false});
  }

  render() {
    if (this.state.notFound) return <NotFoundPage/>;

    if(this.state.loading) {
      return (
        <p>Loading...</p>
        );
    }

    return (
      <div>
        <ErrorComponent error={this.state.errors}/>

        { !this.state.notAssessed ?
          <div>
            <h2 data-cy="report-header" align="center">
                Team Report: {this.state.team.name}
            </h2>
            <br/>
              <div data-cy='progress-bar' align='center'>
                  { this.state.score[0] && this.state.score[0].calculated_score ?
                      <ProgressBarItem
                          placement={'right'}
                          score={this.state.score[0].calculated_score}
                          width={'500px'} /> : null }
              </div>
              <div className='flex-row-spaced'>
                  <div data-cy='assess-date' className="pl1">Date Assessed: {moment(new Date(this.state.score[0].assessment_date)).format('MM/DD/YYYY')}</div>
                  <div data-cy="completed-by" className="pr1">Completed by: {this.state.user}</div>
              </div>
            <AssessmentPage
              disabled
              teamAssessment={this.state.score[0]}
              answers={this.state.answers}
              subScores={this.state.subScores}
            />
          </div>
          :
          <div>
            <br/>
            <h2>Generate an assessment to see the report here.</h2>
          </div>
        }
        </div>
    );

  }
}

export default CoachReportPage;


// WEBPACK FOOTER //
// ./src/components/teams/CoachReportPage.js